import { useState } from "react";
import { Box } from "../../../../../../components/box";
import InformationLayout from "../../../../components/layout/InformationLayout";
import FormButton from "./button";
import FormContent from "./content";

const OfficialVehicleInformation = () => {
  const [pickedItHead, setPickedItHead] = useState(null as any);

  return (
    <InformationLayout>
      <Box title="Thông tin cấp xe công vụ" className="full-height box__detail-container">
        <FormContent
          setPickedItHead={setPickedItHead}
        />
        <FormButton
          pickedItHead={pickedItHead} 
        />
      </Box>
    </InformationLayout>
  );
};

export default OfficialVehicleInformation;
